var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-ote-ai-ques-detail" },
    [
      _vm.create
        ? [
            _c("div", { staticClass: "mb8 color-gray-10 standard-size-14" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("pc_biz_ote_lbl_questiontype" /** 题型 */)) +
                  "\n    "
              ),
            ]),
            _c(
              "div",
              { staticClass: "yxtbiz-ote-ai-ques-detail__type" },
              _vm._l(_vm.typeList, function (item) {
                return _c(
                  "yxt-button",
                  {
                    key: item.value,
                    class:
                      item.value === _vm.currentComponent.type
                        ? "color-primary-6"
                        : "color-gray-9",
                    attrs: {
                      type:
                        item.value === _vm.currentComponent.type
                          ? "second"
                          : "",
                      plain: "",
                      size: "large",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.changeType(item.value)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex flex-mid" },
                      [
                        _c("yxt-svg", {
                          staticClass: "mr8",
                          attrs: {
                            width: "16px",
                            height: "16px",
                            "icon-class": item.iconClass,
                            "remote-url": _vm.SvgMediaUrl,
                          },
                        }),
                        _vm._v(_vm._s(item.label) + "\n        "),
                      ],
                      1
                    ),
                  ]
                )
              }),
              1
            ),
          ]
        : _vm._e(),
      _c(_vm.type[_vm.currentComponent.type], {
        key: 1,
        ref: "currentComponentItem" + 1,
        tag: "component",
        staticClass: "b-radius6",
        attrs: {
          index: 1,
          currentComponent: _vm.currentComponent,
          examType: _vm.examInfo.examType,
          compTitle: _vm.compTitle,
          isAudit: false,
        },
        on: { resetCurrentComponent: _vm.resetCurrentComponent },
      }),
      _c(
        "div",
        { staticClass: "mb8 color-gray-10 yxt-weight-5 standard-size-14" },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("pc_biz_ote_lbl_topicsetting" /** 题目设置 */)) +
              "\n  "
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "yxtbiz-ote-ai-ques-detail__setting" },
        [
          _c(
            "yxt-form",
            {
              attrs: {
                model: _vm.currentComponent,
                rules: _vm.rules,
                "label-width": "100px",
                "label-position": "top",
              },
            },
            [
              _c(
                "div",
                { staticClass: "flex flex-wrap" },
                [
                  _c(
                    "yxt-form-item",
                    {
                      staticClass: "yxtbiz-ote-ai-ques-detail__setting-lang",
                      attrs: {
                        label: _vm.$t("pc_biz_ote_lbl_quesbank"),
                        prop: "libId",
                        size: "small",
                        error: _vm.validateMsg.libMsg,
                      },
                    },
                    [
                      _c(
                        "yxt-select",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.currentComponent.libName,
                              expression: "currentComponent.libName",
                            },
                          ],
                          staticClass: "wp-100",
                          attrs: {
                            size: "small",
                            "icon-name": "more",
                            "value-key": "libId",
                            "prop-label": "libName",
                            "hidden-option": "",
                          },
                          on: { "visible-change": _vm.selLib },
                          model: {
                            value: _vm.currentComponent.libId,
                            callback: function ($$v) {
                              _vm.$set(_vm.currentComponent, "libId", $$v)
                            },
                            expression: "currentComponent.libId",
                          },
                        },
                        [
                          _c("yxt-option", {
                            key: _vm.currentComponent.libId,
                            attrs: {
                              label: _vm.currentComponent.libName,
                              value: _vm.currentComponent.libId,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "yxt-form-item",
                    {
                      staticClass: "yxtbiz-ote-ai-ques-detail__setting-short",
                      attrs: {
                        label: _vm.$t("pc_biz_ote_lbl_hardlevel"),
                        prop: "levelType",
                        size: "small",
                      },
                    },
                    [
                      _c(
                        "yxt-select",
                        {
                          staticClass: "wp-100",
                          attrs: {
                            placeholder: _vm.$t("pc_biz_ote_lbl_all"),
                            size: "small",
                          },
                          model: {
                            value: _vm.currentComponent.levelType,
                            callback: function ($$v) {
                              _vm.$set(_vm.currentComponent, "levelType", $$v)
                            },
                            expression: "currentComponent.levelType",
                          },
                        },
                        _vm._l(_vm.levelTypeList, function (item) {
                          return _c("yxt-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "yxt-form-item",
                    {
                      staticClass: "yxtbiz-ote-ai-ques-detail__setting-lang",
                      attrs: {
                        size: "small",
                        label: _vm.$t("pc_biz_ote_lbl_assessmentpoint"),
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "wp-100 min-h-32" },
                        [
                          _vm.currentComponent.libId
                            ? _c("ques-point-selector", {
                                staticClass: "wp-100",
                                attrs: {
                                  selectClass: "wp-100",
                                  "multiple-limit": _vm.pointNumLimit,
                                  placeholder: _vm.$t(
                                    "pc_biz_ote_lbl_pleaseselect3"
                                  ),
                                  libId: _vm.currentComponent.libId,
                                  selectSize: "small",
                                },
                                model: {
                                  value: _vm.currentComponent.pointIds,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.currentComponent,
                                      "pointIds",
                                      $$v
                                    )
                                  },
                                  expression: "currentComponent.pointIds",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "mt24 mb8" },
        [
          _c(
            "yxt-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.saveForm()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("pc_biz_ote_lbl_save")))]
          ),
          _c(
            "yxt-button",
            {
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("pc_biz_ote_btn_cancle")))]
          ),
        ],
        1
      ),
      _c(
        "yxt-drawer",
        {
          staticClass: "yxtbiz-lib-selector__select-drawer",
          attrs: {
            title: _vm.$t("pc_biz_ote_msg_selqueslib"),
            visible: _vm.selectLibDrawerData.isShowSelectLibDrawer,
            size: "960px",
            "destroy-on-close": true,
            "before-close": function (done) {
              return done(
                _vm.$refs.selectLib && _vm.$refs.selectLib.dialogEdited
              )
            },
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(
                _vm.selectLibDrawerData,
                "isShowSelectLibDrawer",
                $event
              )
            },
          },
        },
        [
          _c("yxtbiz-lib-selector", {
            ref: "selectLib",
            attrs: {
              needCreateLib: "",
              createType: _vm.examId ? 1 : 0,
              states: _vm.selectLibDrawerData,
            },
            on: {
              selectLibCallback: _vm.selectLibCallback,
              closeSelectLibDrawer: _vm.closeSelectLibDrawer,
            },
          }),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "yxt-button",
                { attrs: { plain: "" }, on: { click: _vm.selectLibClose } },
                [_vm._v(_vm._s(_vm.$t("pc_biz_ote_btn_cancle")))]
              ),
              _c(
                "yxt-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.selectLibSubmit },
                },
                [_vm._v(_vm._s(_vm.$t("pc_biz_ote_btn_confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }